<template>
  <div class="mic-control-container">
    <p class="smaller-semibold accent">{{ t('label_interpretation_speed') }}</p>

    <Gauge
      :model-value="speed"
      :disabled="false"
      :min="0"
      :max="2"
      :increment="1"
      :min-label="t('label_slow')"
      :max-label="t('label_fast')"
      @update:model-value="handleInterpretationSpeed"
    />
  </div>
</template>
<script lang="ts" setup>
import { watch, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import Gauge from '@/components/shared/base/Gauge.vue';
import { useSocketStore } from '@/stores/socket';
import { InterpretationSpeed, InterpretationSpeedValue } from '@/types/socket';
import { INTERPRETATION_SPEED } from '@/utils/constants/chat';

const socketStore = useSocketStore();
const { t } = useI18n();

const speed = ref<InterpretationSpeedValue>(0);

const initInterpretationSpeed = (val: InterpretationSpeed) => {
  speed.value = INTERPRETATION_SPEED[val];
};

const handleInterpretationSpeed = (val: number) => {
  const fixedType = INTERPRETATION_SPEED[val] as InterpretationSpeed;
  socketStore.sendMessageFP({ fixedType });
};

watch(
  () => socketStore.interpretationSpeed,
  (val) => {
    initInterpretationSpeed(val);
  },
  { immediate: true }
);
</script>

<style scoped lang="scss">
.mic-control-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: fit-content;
  gap: 0.75rem;
  color: var(--font-default);
}
</style>
